import SearchableSelect from './SearchableSelect';
import { defaultOptionLabel, defaultOptionValue } from '../../utils/selectOptions';

/**
 * Form select with label/validation — alphabetically sorted + type-to-search.
 */
const FormSelect = ({
  label,
  name,
  value,
  onChange,
  options = [],
  placeholder = 'Select...',
  required = false,
  helpText,
  error,
  disabled = false,
  creatable = false,
  className = '',
  getOptionLabel = defaultOptionLabel,
  getOptionValue = defaultOptionValue,
}) => {
  const fieldId = `select-${name}`;
  const hasError = !!error;

  return (
    <div className={`mb-4 ${className}`}>
      {label && (
        <label
          htmlFor={fieldId}
          className="block text-gray-700 dark:text-gray-200 mb-2 font-medium text-sm"
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      <SearchableSelect
        id={fieldId}
        name={name}
        value={value}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        error={hasError}
        creatable={creatable}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        aria-label={label || placeholder}
      />

      {error && (
        <p className="mt-1.5 text-sm text-red-600 dark:text-red-400">{error}</p>
      )}

      {helpText && !error && (
        <p className="mt-1.5 text-xs text-gray-500 dark:text-gray-400">{helpText}</p>
      )}
    </div>
  );
};

export default FormSelect;
